import Vue from 'vue';

export const history = {
  namespaced: true,
  state: {
    history: [],
  },
  actions: {
    push({ commit }, routeName) {
      commit('pushHistory', routeName);
    },
  },
  mutations: {
    pushHistory(state, routeName) {
      state.history.push(routeName);
      Vue.set(state, 'history', state.history);
    },
  },
  getters: {
    history: state => {
      return state.history;
    },
  },
};
